// src/components/forms/PasswordInput.tsx
import { FC, useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";

interface Props {
  label: string;
  value: string;
  name: string;
  // onChange: (val: string) => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
}

export const PasswordInput: FC<Props> = ({ label, value, name,onChange, placeholder, className }) => {
  const [show, setShow] = useState(false);

  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {/* Colorful Indigo Label */}
      <label className="text-sm font-bold text-slate-200 dark:text-indigo-200 ml-1">
        {label}
      </label>

      <div className="relative group">
        {/* Animated Gradient Background Glow */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 rounded-xl opacity-20 group-focus-within:opacity-100 transition duration-300 blur-[2px]"></div>
        
        <input
        name={name}
          type={show ? "text" : "password"}
          value={value}
          placeholder={placeholder}
          // onChange={(e) => onChange(e.target.value)}
         onChange={onChange}
          className="relative w-full rounded-xl bg-white dark:bg-zinc-900 px-4 py-2.5 pr-12
                     text-zinc-900 dark:text-zinc-100 
                     placeholder:text-zinc-400
                     border border-zinc-200 dark:border-zinc-700
                     focus:border-transparent focus:outline-none 
                     transition-all duration-200"
        />

        {/* Eye Toggle Button with Color State */}
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center pr-4 z-10"
          onClick={() => setShow(!show)}
        >
          {show ? (
            <EyeSlashIcon className="w-5 h-5 text-pink-500 hover:text-pink-600 transition-colors" />
          ) : (
            <EyeIcon className="w-5 h-5 text-indigo-400 hover:text-indigo-500 transition-colors" />
          )}
        </button>
      </div>
    </div>
  );
};